import { render, staticRenderFns } from "./HMCheckBoxGroupTeacher.vue?vue&type=template&id=cb315242&scoped=true&"
import script from "./HMCheckBoxGroupTeacher.vue?vue&type=script&lang=ts&"
export * from "./HMCheckBoxGroupTeacher.vue?vue&type=script&lang=ts&"
import style0 from "./HMCheckBoxGroupTeacher.vue?vue&type=style&index=0&id=cb315242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb315242",
  null
  
)

export default component.exports